import { render, staticRenderFns } from "./PageABCBookChapters.vue?vue&type=template&id=04c66937&scoped=true&"
import script from "./PageABCBookChapters.vue?vue&type=script&lang=js&"
export * from "./PageABCBookChapters.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBookChapters.vue?vue&type=style&index=0&id=04c66937&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c66937",
  null
  
)

export default component.exports